import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./company.actions.component.html')
})
export class CompanyActionsComponent {
  @Input() record: any;

  @Output() onAccountingClick: EventEmitter<any> = new EventEmitter();
  @Output() onChargifyClick  : EventEmitter<any> = new EventEmitter();
  @Output() onRecordsClick   : EventEmitter<any> = new EventEmitter();
  @Output() onUsersClick     : EventEmitter<any> = new EventEmitter();
}